import { CompanyBankComponent } from 'app/pages/companies/company-banks/company-bank/company-bank.component';
import { CompanyComponent } from 'app/pages/companies/company/company.component';
import {
  EmailMessageDetailsComponent
} from 'app/pages/email-messages/email-message-details/email-message-details.component';
import { SendEmailMessageComponent } from 'app/pages/email-messages/send-email-message/send-email-message.component';
import {
  FinancialTransactionDetailsComponent
} from 'app/pages/financial-transactions/financial-transaction-details/financial-transaction-details.component';
import { ModuleDetailsComponent } from 'app/pages/modules/module-details/module-details.component';
import { ModuleComponent } from 'app/pages/modules/module/module.component';
import {
  PaymentRequestInformationComponent
} from 'app/pages/payment-requests/payment-request-information/payment-request-information/payment-request-information.component';
import {
  PaymentRequestUrlComponent
} from 'app/pages/payment-requests/payment-request-url/payment-request-url.component';
import { PaymentRequestComponent } from 'app/pages/payment-requests/payment-request/payment-request.component';
import { PaymentActionComponent } from 'app/pages/payment-actions/payment-action/payment-action.component';
import { SendSmsMessageComponent } from 'app/pages/sms-messages/send-sms-message/send-sms-message.component';
import { SmsMessageDetailsComponent } from 'app/pages/sms-messages/sms-message-details/sms-message-details.component';
import { UserPreSharedKeyComponent } from 'app/pages/users/user-presharedkey/user-presharedkey.component';
import { UserComponent } from 'app/pages/users/user/user.component';
import { Modals } from 'app/shared/constants/modals';
import { PaymentActionsUrlComponent } from 'app/pages/payment-actions/payment-actions-url/payment-actions-url.component';
import { ModelComponent as DocumentIntelligenceModelComponent } from '../../pages/document-intelligence/model/model.component';

export let ModalComponentFactory: any[] = [
  { name: Modals.CompanyComponent, component: CompanyComponent },
  { name: Modals.CompanyBankComponent, component: CompanyBankComponent },
  { name: Modals.EmailMessageDetailsComponent, component: EmailMessageDetailsComponent },
  { name: Modals.FinancialTransactionDetailsComponent, component: FinancialTransactionDetailsComponent },
  { name: Modals.ModuleComponent, component: ModuleComponent },
  { name: Modals.ModuleDetailsComponent, component: ModuleDetailsComponent },
  { name: Modals.PaymentActionComponent, component: PaymentActionComponent },
  { name: Modals.PaymentActionsUrlComponent, component: PaymentActionsUrlComponent },
  { name: Modals.PaymentRequestComponent, component: PaymentRequestComponent },
  { name: Modals.PaymentRequestInformationComponent, component: PaymentRequestInformationComponent },
  { name: Modals.PaymentRequestUrlComponent, component: PaymentRequestUrlComponent },
  { name: Modals.SendEmailMessageComponent, component: SendEmailMessageComponent },
  { name: Modals.SendSmsMessageComponent, component: SendSmsMessageComponent },
  { name: Modals.SmsMessageDetailsComponent, component: SmsMessageDetailsComponent },
  { name: Modals.UserComponent, component: UserComponent },
  { name: Modals.UserPreSharedKeyComponent, component: UserPreSharedKeyComponent },
  { name: Modals.DocumentIntelligenceModelComponent, component: DocumentIntelligenceModelComponent}
];
